/**
 * カードを画像で選ぶ（Issue #317）。場所ごとの見出しの下にカードの画像のタイルを並べる。
 *
 * Props: groups（cardLocations.ownedCardsByLocation の戻り）/ selectedCode / playerLabel(team) / onPick(code) / onClose
 */
export const TILE_W = 59;
export const TILE_H = 80;

export function CardTile({ card, selected = false, onClick, small = false, title }) {
  const w = small ? 30 : TILE_W, h = small ? 41 : TILE_H;
  const body = card?.image
    ? <img src={card.image} alt={card.name} width={w} height={h} style={{ display: 'block', objectFit: 'cover', borderRadius: 3 }} />
    : <div style={{ width: w, height: h, borderRadius: 3, background: '#3a2a14', color: '#ddd', fontSize: small ? 8 : 10, overflow: 'hidden',
        display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 2, boxSizing: 'border-box' }}>{card?.name ?? '？'}</div>;
  if (!onClick) return <span title={title ?? card?.name} style={{ display: 'inline-block' }}>{body}</span>;
  return (
    <button type="button" onClick={onClick} title={title ?? card?.name} data-code={card?.code}
            style={{ position: 'relative', padding: 2, border: `2px solid ${selected ? '#ffd36b' : 'transparent'}`, borderRadius: 5,
              background: selected ? '#443' : 'transparent', cursor: 'pointer' }}>
      {body}
      {card?.count > 1 && (
        <span style={{ position: 'absolute', right: 2, bottom: 2, background: '#000c', color: '#fff', fontSize: 10, padding: '0 3px', borderRadius: 3 }}>
          ×{card.count}
        </span>
      )}
    </button>
  );
}

export default function CardPicker({ groups = [], selectedCode = null, playerLabel = (t) => `P${t + 1}`, onPick, onClose }) {
  return (
    <div role="dialog" aria-label="カードを選ぶ" style={{ border: '1px solid #555', borderRadius: 4, padding: 6, margin: '4px 0', background: '#1b1f24' }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
        <span style={{ fontSize: '0.8rem', color: '#aaa' }}>カードを選ぶ（今ある場所ごと）</span>
        <button type="button" className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto' }} onClick={onClose}>閉じる</button>
      </div>
      {groups.length === 0 && <div style={{ color: '#888', fontSize: '0.8rem' }}>選べるカードがありません</div>}
      {groups.map((g) => (
        <div key={g.location} data-location={g.location} style={{ marginBottom: 4 }}>
          <div style={{ fontSize: '0.75rem', color: '#9ab' }}>{g.label}（{g.cards.reduce((n, c) => n + c.count, 0)}）</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
            {g.cards.map((c) => (
              <CardTile key={c.key} card={c} selected={selectedCode === c.code} onClick={() => onPick?.(c.code)}
                        title={`${c.name}（${g.label}${g.location === 'maindeck' ? '' : `・${playerLabel(c.controller)}側`}）`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
